import DeviceDetector from "device-detector-js";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Navigate, useParams } from "react-router-dom";
import { APP_CONST } from "../../../../config/const";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { socket, socketFunc } from "../../../../utils/socketUtil";
import { Toaster } from "../../../../utils/toaster";
import Header from "../../../../containers/Header";
import { addMetaTags, openGraphTags } from "../../../../utils/addMetaTags";
import LeftBarSports from "../../../components/LeftBarSports";

export const PAGE_LOAD_TYPE = {
  PAGE: "page",
  COMPONENT: "component",
};

const ExchangeLobbyPage = ({
  loadType = PAGE_LOAD_TYPE.PAGE,
  isAuth = true,
}) => {
  const [casinoLobbyUrl, setCasinoLobbyUrl] = useState();

  let { gameId } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    updateMetaTags();
    const deviceDetector = new DeviceDetector();
    const userAgent = window.navigator.userAgent;
    const device = deviceDetector.parse(userAgent);

    // console.log({ mobile: device?.device?.type === "smartphone" });
    if (isAuth) {
      socketFunc(token).emit(
        "get:jetfair_lobby",
        {
          mobile: device?.device?.type === "smartphone",
          sportName: gameId,
          theme: "light",
        },
        (res) => {
          if (res?.status === "failed") {
            Toaster(APP_CONST.TOAST_TYPE.ERROR, res.message);

            return setCasinoLobbyUrl("notAllowed");
          }
          if (res?.status === "success" && res?.data?.errorCode) {
            Toaster(APP_CONST.TOAST_TYPE.ERROR, res?.data?.message);

            return setCasinoLobbyUrl("notAllowed");
          }

          setCasinoLobbyUrl(
            res?.data?.data?.lobbyUrl?.replace("light", "light") || "notFound"
          );
        }
      );
    } else {
      setCasinoLobbyUrl("https://design.powerplay247.com/auth?theme=light");
    }

    return () => {
      socket.off("get:jetfair_lobby");
    };
  }, [gameId, isAuth]);

  const updateMetaTags = () => {
    addMetaTags({
      title: " Funn777 - Sports Exchange",
      description:
        "Funn777 is a crypto-accepting platform offering a premier experience in online sports betting, casino gaming, and E-sports. Join Funn777 to enjoy live sports events, innovative casino games with fast withdrawals, secure transactions, and safe gambling practices. Sign up today on Funn777.com – your trusted crypto gambling platform for modern sports betting and live casino gaming.",
      keywords:
        "Initial coin offering through betting, Funn777, Crypto Betting, Crypto Casino, Virtual Asset Casino, Online Sports Betting, Casino Gaming, Live Betting, Secure Online Gambling, crypto gambling, Poker, Slots Games, Cricket, Tennis, Andar Bahar, Fast Payouts, Sports Events, Online Casino, Funn777 popular games, Betting Platform, Safe Gambling, Trusted Betting Site, Funn777.com, Popular Betting site",
      metaUrl: "https://Funn777.com/sports/Inplay",
    });
    openGraphTags({
      ogTitle: " Funn777 - Sports Exchange",
      ogDescription:
        " Funn777 is a crypto-accepting platform offering a premier experience in online sports betting, casino gaming, and E-sports. Join Funn777 to enjoy live sports events, innovative casino games with fast withdrawals, secure transactions, and safe gambling practices. Sign up today on Funn777.com – your trusted crypto gambling platform for modern sports betting and live casino gaming.",
      // ogImage: "../../../../assets/images/seo/og_tags_1024_512.png",
      ogUrl: "https://Funn777.com/sports/Inplay",
      ogType: "website",
      ogKeywords:
        "Initial coin offering through betting, Funn777, Crypto Betting, Crypto Casino, Virtual Asset Casino, Online Sports Betting, Casino Gaming, Live Betting, Secure Online Gambling, crypto gambling, Poker, Slots Games, Cricket, Tennis, Andar Bahar, Fast Payouts, Sports Events, Online Casino, Funn777 popular games, Betting Platform, Safe Gambling, Trusted Betting Site, Funn777.com, Popular Betting site",
    });
  };

  return (
    <>
      {loadType == PAGE_LOAD_TYPE.PAGE ? (
        isAuth ? (
          <HeaderAfterLogin />
        ) : (
          <Header />
        )
      ) : null}

      <main className="main">
        <div className="main-page">
          <LeftBarSports />

          <div className="main-content">
            {isAuth ? (
              <div className="exchangeLobby">
                <div className="live_casino_page live">
                  {!Boolean(casinoLobbyUrl) ? (
                    <div className="custom_placeholder_parent">
                      <div className="custom_placeholder_child">
                        <Spinner animation="grow" variant="primary" size="sm" />
                        <Spinner animation="grow" variant="primary" size="sm" />
                        <Spinner animation="grow" variant="primary" size="sm" />
                      </div>
                    </div>
                  ) : casinoLobbyUrl === "notAllowed" ? (
                    <Navigate to="/home" />
                  ) : casinoLobbyUrl === "notFound" ? (
                    <Navigate to="/home" />
                  ) : (
                    <div className="exchange_iframe">
                      <iframe
                        title="Exchange"
                        src={casinoLobbyUrl}
                        frameBorder="0"
                        style={{
                          width: "100%",
                          border: "2px solid #27ae60",
                          borderRadius: "15px",
                        }}
                        // scrolling="no"
                        allowFullScreen={true}
                      >
                        Your browser doesn't support iFrames.
                      </iframe>
                    </div>
                  )}
                  {/*  Iframe End */}
                </div>
              </div>
            ) : (
              <div className="exchangeLobby">
                <div className="live_casino_page live">
                  <div className="exchange_iframe">
                    <iframe
                      src={casinoLobbyUrl}
                      style={{
                        width: "100%",
                        border: "2px solid #27ae60",
                        borderRadius: "15px",
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default ExchangeLobbyPage;
